import { GeneralObjectKey } from "src/modules/enaio/netgen/GeneralObjectKey";
import { Comparable } from "src/modules/utils/shared/comparable";
import { Objects } from "src/modules/utils/shared/objects";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { GeneralObjectActionProvider } from "./general-object-action-provider.model";
import { ToolTipDefinition } from "./ToolTipDefinition.model";

export class TableCell implements Comparable<TableCell> {

    static getValue(value: any): any {
        return value instanceof TableCell ? value.value : value;
    }

    static getComparable(value: any): any {
        return value instanceof TableCell ? value.comparable ?? value.value : value;
    }

    value: any;
    comparable: any;
    styleClass: string;
    style: OrdinaryObject;
    colSpan = 1;
    keepHtml: boolean;
    internal: GeneralObjectKey[];
    data: OrdinaryObject;
    toolTip: ToolTipDefinition;
    actionsAsContextMenu = false;
    actionProviders: GeneralObjectActionProvider[];

    constructor (value: any, props: Partial<TableCell> = null) {
        this.value = value;
        if (props != null) {
            Object.assign(this, props);
        }
    }

    compareTo(other: TableCell): number {
        return Objects.cmp(this.comparable ?? this.value, TableCell.getComparable(other));
    }

}